import PresetCompareModal from './presetCompareModal';

export default PresetCompareModal;